import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

// Get all users
export const fetchAllUsers = createAsyncThunk('admin/fetchAllUsers', async () => {
  return await api.get('/admin/users');
});

// Get single user
export const fetchUserDetail = createAsyncThunk('admin/fetchUserDetail', async (userId) => {
  return await api.get(`/admin/users/${userId}`);
});

// Get all payments
export const fetchAllPayments = createAsyncThunk('admin/fetchAllPayments', async () => {
  return await api.get('/admin/payments');
});

// Get all invoices
export const fetchAllInvoices = createAsyncThunk('admin/fetchAllInvoices', async () => {
  return await api.get('/admin/invoices');
});

// Get admin overview data
export const fetchAdminOverview = createAsyncThunk('admin/fetchAdminOverview', async () => {
  return await api.get('/admin/overview');
});

// Get SaaS metrics (MRR, churn, conversion, DAU/MAU, revenue trend)
export const fetchSaasMetrics = createAsyncThunk('admin/fetchSaasMetrics', async () => {
  return await api.get('/admin/metrics');
});

// Extend plan
export const extendUserPlan = createAsyncThunk('admin/extendUserPlan', async ({ userId, daysToAdd }) => {
  return await api.put(`/admin/override/extend-plan/${userId}`, { daysToAdd });
});

// Reset usage
export const resetUserUsage = createAsyncThunk('admin/resetUserUsage', async (userId) => {
  return await api.put(`/admin/override/reset-usage/${userId}`, {});
});

// Resolve payment
export const resolvePaymentAdmin = createAsyncThunk('admin/resolvePaymentAdmin', async (paymentId) => {
  return await api.put(`/admin/override/resolve-payment/${paymentId}`, {});
});

// Get audit logs
export const fetchAuditLogs = createAsyncThunk('admin/fetchAuditLogs', async (userId) => {
  return await api.get(`/admin/override/audit-logs/${userId}`);
});

// Toggle user status (ACTIVE / SUSPENDED)
export const toggleUserStatus = createAsyncThunk('admin/toggleUserStatus', async ({ userId, status }) => {
  return await api.put(`/admin/users/${userId}/status`, { status });
});

// Change user plan (FREE / PRO)
export const changeUserPlan = createAsyncThunk('admin/changeUserPlan', async ({ userId, plan }) => {
  return await api.put(`/admin/users/${userId}/plan`, { plan });
});

// Grant admin privileges
export const makeUserAdmin = createAsyncThunk('admin/makeUserAdmin', async (userId) => {
  return await api.create(`/admin/users/${userId}/make-admin`, {});
});

// Revoke admin privileges
export const revokeUserAdmin = createAsyncThunk('admin/revokeUserAdmin', async (userId) => {
  return await api.delete(`/admin/users/${userId}/revoke-admin`);
});

// Fetch contact enquiries (support tickets from contact form)
export const fetchContactEnquiries = createAsyncThunk('admin/fetchContactEnquiries', async () => {
  return await api.get('/support/admin/tickets');
});

// Fetch suspended accounts
export const fetchSuspendedAccounts = createAsyncThunk('admin/fetchSuspendedAccounts', async () => {
  return await api.get('/admin/suspended-accounts');
});

// Permanently delete a user and all related data
export const permanentlyDeleteUser = createAsyncThunk('admin/permanentlyDeleteUser', async (userId) => {
  return await api.delete(`/admin/users/${userId}/permanent-delete`);
});

// Reactivate a suspended account
export const reactivateUser = createAsyncThunk('admin/reactivateUser', async (userId) => {
  return await api.put(`/admin/users/${userId}/reactivate`, {});
});

// Fetch user activity summary (page visits, sessions, etc.)
export const fetchUserActivity = createAsyncThunk('admin/fetchUserActivity', async (userId) => {
  return await api.get(`/admin/users/${userId}/activity`);
});
